import { SENTRY_CONFIG } from "Infrastructure/Utils/SentryUtils";
import { captureException } from "@sentry/react";

export function logError(
	error: Error,
	additionalInfo?: unknown,
	isUserDialogShown = true,
): void {
	if (SENTRY_CONFIG.IS_ENABLED) {
		captureException(error, {
			extra: {
				additionalInfo,
				doNotShowDialog: !isUserDialogShown,
			},
		});
		return;
	}
	// biome-ignore lint/suspicious/noConsole: dev-only fallback when Sentry is disabled
	console.error(error, additionalInfo);
}
